"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntentDetectionRate = void 0;
var IntentDetectionRate = /** @class */ (function (_super) {
    __extends(IntentDetectionRate, _super);
    function IntentDetectionRate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "IntentDetectionRate";
        _this.detected = function () {
            _this.push(function (_) { return "detected"; });
        };
        _this.unaware = function () {
            _this.push(function (_) { return "unaware"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return IntentDetectionRate;
}(Array));
exports.IntentDetectionRate = IntentDetectionRate;
//# sourceMappingURL=IntentDetectionRate.js.map